import { render, staticRenderFns } from "./CapitalTaxGainsCalculator.vue?vue&type=template&id=32e1f6fa&scoped=true"
import script from "./CapitalTaxGainsCalculator.vue?vue&type=script&lang=js"
export * from "./CapitalTaxGainsCalculator.vue?vue&type=script&lang=js"
import style0 from "./CapitalTaxGainsCalculator.vue?vue&type=style&index=0&id=32e1f6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1f6fa",
  null
  
)

export default component.exports